export const FETCH_EMPLOYER_AUTHORIZATION_CODE = "AUTHORIZATION.FETCH_EMPLOYER_AUTHORIZATION_CODE";